import { render, staticRenderFns } from "./dashboardStatsComponent.vue?vue&type=template&id=480444a6"
import script from "./dashboardStatsComponent.vue?vue&type=script&lang=js"
export * from "./dashboardStatsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports